import { defineMessages } from 'react-intl';

type MessageKeys = 'addAgentLabel' | 'viewAllAgentsLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		addAgentLabel: {
			id: 'ai-mate.rovo-navigation.agents-items.add-agent',
			defaultMessage: 'Create agent',
			description: 'Label for the add agent menu item',
		},
		viewAllAgentsLabel: {
			id: 'ai-mate.rovo-navigation.agents-items.view-all',
			defaultMessage: 'View all agents',
			description: 'Label for the view all agents menu item',
		},
	});

export default message;
